if (!customElements.get('required-variant-picker')) {
  class RequiredVariantPicker extends HTMLElement {
    constructor() {
      super();

      // Initialize minimal data needed for variant selection
      this.section = this.closest('.required-group');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();
      this.variant = this.getSelectedVariant();
      this.selectedOptions = this.getSelectedOptions();
      this.addEventListener('change', this.handleVariantChange.bind(this));
    }

    handleVariantChange(evt) {
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();

      // Dispatch initialization event for extensions (needed for button validation)
      setTimeout(() => {
        this.dispatchEvent(new CustomEvent('on:variant-picker:ready', {
          bubbles: true,
          detail: { variantPicker: this }
        }));
        // Only run safe methods for required addons
        this.updatePrice();
        RequiredVariantPicker.updateLabelText(evt);
        this.dispatchEvent(new CustomEvent('on:required-variant:change', {
          bubbles: true,
          detail: {
            variant: this.variant
          }
        }));
      })

    }
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }
    updatePrice() {
      this.price = this.section.querySelector('.price');
      if (!this.price || !this.variant || !this.variant.priceNoCurrency) return;
      const priceCurrentEl = this.price.querySelector('.price__current');
      priceCurrentEl.innerHTML = this.variant.priceNoCurrency;
    }

    getProductData() {
      const dataEl = this.section.querySelector('#required-variants-json');
      return JSON.parse(dataEl.textContent);
    }

    getSelectedVariant() {
      const selectedOptions = this.getSelectedOptions();
      return this.data.product.variants.find(
        (v) => v.options.every((val, index) => val === selectedOptions[index])
      );
    }

    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const selectedText = selector.querySelector('.custom-select__btn').textContent.trim();
          selectedOptions.push(selectedText === this.dataset.placeholderText ? null : selectedText);
        } else {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        }
      });

      return selectedOptions;
    }
  }
  customElements.define('required-variant-picker', RequiredVariantPicker);
}